import {UIRouterReact, servicesPlugin, hashLocationPlugin} from '@uirouter/react';
//import {visualizer} from '@uirouter/visualizer';
import { GeckoLoadingService, GeckoToastService } from '@geckolabs/gecko-react-ui';

// Pages
import fourofour from './pages/404/state';
import id from './pages/id/state';
import rsvp from './pages/rsvp/state';
import stream from './pages/stream/state';
import rsvpLiteGuests from './pages/rsvp-lite-guests/state';
import rsvpLiteSessions from './pages/rsvp-lite/sessions/state';
import rsvpLiteSession from './pages/rsvp-lite/session/state';

const appStates = [
	fourofour,
	id,
	rsvp,
	stream,
	rsvpLiteGuests,
	rsvpLiteSessions,
	rsvpLiteSession
];

// Create a new instance of the Router
export const router = new UIRouterReact();
router.plugin(servicesPlugin);
router.plugin(hashLocationPlugin);

// Register the initial (eagerly loaded) states
appStates.forEach(state => router.stateRegistry.register(state));

// Initial state when the router is first loaded
router.urlService.rules.initial({ state: '404' });
// Fallback page if state can't be found
router.urlService.rules.otherwise({ state: '404' });

// Register the "requires auth" hook with the TransitionsService
//import reqAuthHook from './global/requiresAuth.hook';
//router.transitionService.onBefore(reqAuthHook.criteria, reqAuthHook.callback, {priority: 10});

router.transitionService.onBefore(true, function() {
	//console.log('React Nav Start');
	return new GeckoLoadingService().show();
});

router.transitionService.onSuccess(true, function(trans) {
	// Remove init loading (on first load)
    if (window.removeLoading) setTimeout(() => window.removeLoading(), 500);

    // Add page class to the body tag
    document.getElementsByTagName('body')[0].className = router.stateService.$current.name === 'stream' ? 'stream-page' : 'rsvp-page';

    window.scrollTo(0, 0);

	//console.log('React Nav End');
	return new GeckoLoadingService().hide();
});

router.transitionService.onError(true, function(err) {
	try {
		console.log('React Nav Error', err.error());
		// Show error alert
		if (err.error().detail && err.error().detail.message) {
			new GeckoToastService().error(err.error().detail.message);
		}

		return new GeckoLoadingService().hide();
	} catch(e) {}	
});

// Start the router
//router.start();

// Setup the state visualizer
//visualizer(router);

// Alias
export let $state       = router.stateService;
export let $stateParams = router.globals.params;



